import { createContext } from "react";

const BlockContext = createContext();

export default BlockContext;
